var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.18,
    height: 47.92,
    viewBox: "0 0 46.18 47.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0,24.01c0,13.18,10.68,23.91,23.81,23.91,5.76,0,11.33-2.13,15.7-5.99l2.92-2.58-3.9.13c-10.84.37-17.52-6.58-20.16-13.21-3.36-8.42-1.19-17.72,5.54-23.67l2.93-2.59-3.91.14C10.17.61,0,11.16,0,24.01Zm15.77,3.29c3.15,7.91,10.05,13.67,18.81,14.79-3.25,1.97-6.97,3.03-10.77,3.03-11.59,0-21.01-9.47-21.01-21.11C2.8,13.92,9.77,5.51,19.24,3.42c-5.55,6.82-6.67,15.85-3.47,23.87Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.48,23.82l-1.26-2.57-1.26,2.57c-.66,1.36-1.78,2.47-3.13,3.13l-2.57,1.26,2.57,1.26c1.36.66,2.47,1.78,3.13,3.13l1.26,2.57,1.26-2.57c.66-1.36,1.78-2.47,3.13-3.13l2.57-1.26-2.57-1.26c-1.36-.66-2.47-1.78-3.13-3.13Zm-1.26,5.61c-.37-.44-.78-.85-1.22-1.22.44-.37.85-.78,1.22-1.22.37.44.78.85,1.22,1.22-.44.37-.85.78-1.22,1.22Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.27,12.61l-1.26-2.57-1.26,2.57c-.66,1.36-1.78,2.47-3.13,3.13l-2.57,1.26,2.57,1.26c1.36.66,2.47,1.78,3.13,3.13l1.26,2.57,1.26-2.57c.66-1.36,1.78-2.47,3.13-3.13l2.57-1.26-2.57-1.26c-1.36-.66-2.47-1.78-3.13-3.13Zm-1.26,5.61c-.37-.44-.78-.85-1.22-1.22.44-.37.85-.78,1.22-1.22.37.44.78.85,1.22,1.22-.44.37-.85.78-1.22,1.22Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.61,7.34c-1.36-.66-2.47-1.78-3.13-3.13l-1.26-2.57-1.26,2.57c-.66,1.36-1.78,2.47-3.13,3.13l-2.57,1.26,2.57,1.26c1.36.66,2.47,1.78,3.13,3.13l1.26,2.57,1.26-2.57c.66-1.36,1.78-2.47,3.13-3.13l2.57-1.26-2.57-1.26Zm-4.39,2.48c-.37-.44-.78-.85-1.22-1.22.44-.37.85-.78,1.22-1.22.37.44.78.85,1.22,1.22-.44.37-.85.78-1.22,1.22Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.1980f9d7bc54315f756a6025f3e232f6.svg";
export { ForwardRef as ReactComponent };